import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
    id: 'FULLBOARD',
    analyticsName: 'Full board',
    queryKey: 'f_fullBoard',
    type: FILTER_TYPES.BOOLEAN,
    bucketify: (hotel) => {

        const boardCode = hotel?.boardCode;

        if ( boardCode === 'F' || boardCode === 'FW' ) {
            return {
                bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
                bucketName: 'fullBoard'
            };
        }

        return {
            bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
            bucketName: 'fullBoard'
        };

    },
    toQuery: ({ value }) => {
        return value ? 1 : undefined;
    },
    fromQuery: (rawQueryValue) => {
        return {
            [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue
        };
    }
}));
